import React from 'react';
import GenericModal from '../GenericModal';
import RegiaoComprasDrillDownContent from './RegiaoComprasDrillDownContent';
import { RegiaoComprasDrillDownData } from '../../types/regiaoComprasDrillDown';
import { Box, Typography } from '@mui/material';
import { ProductDrillDownSkeleton } from '../Skeletons/ModalSkeletons';

interface RegiaoComprasDrillDownModalProps {
  isOpen: boolean;
  onClose: () => void;
  data: RegiaoComprasDrillDownData | null;
  loading: boolean;
  error: string | null;
  selectedRegiao: { nome: string } | null;
  onRetry: () => void;
}

const RegiaoComprasDrillDownModal: React.FC<RegiaoComprasDrillDownModalProps> = ({
  isOpen, onClose, data, loading, error, selectedRegiao, onRetry
}) => {
  return (
    <GenericModal
      open={isOpen}
      onClose={onClose}
      title={`Detalhes de Compras - Região: ${selectedRegiao?.nome || 'N/A'}`}
      loading={false}
      maxWidth="lg"
      fullWidth
    >
        {loading ? (
          <ProductDrillDownSkeleton />
        ) : error ? (
            <Box sx={{ padding: 3, textAlign: 'center' }}>
                <Typography color="error">{error}</Typography>
                <button onClick={onRetry}>Tentar Novamente</button>
            </Box>
        ) : (
            data && <RegiaoComprasDrillDownContent data={data} />
        )}
    </GenericModal>
  );
};

export default RegiaoComprasDrillDownModal; 